export * from './src/events-v3-ticket-definition-ticket-definitions-v-2.meta.js';
